module.exports = __webpack_public_path__ + "img/21.60ae2d68.jpg";